import {Base64ObjectInput, QuestionStatus} from '@cp/model';
import {QuestionFormData} from '../../../types/QuestionFormData';

/**
 * Convert QuestionFormData to question input data for create/update operations
 */
export interface QuestionInputData {
  moduleId: string;
  questionText: string;
  hint?: string;
  options: string[];
  answer: string;
  explanation: string;
  topic: string;
  difficulty: number;
  status?: QuestionStatus;
  statusNote?: string;
  image?: Base64ObjectInput | null;
  graphJsonString?: string | null;
}

/**
 * Map QuestionFormData to question input data for mutations
 * Validates and filters the data, returning null if validation fails
 */
export default function mapQuestionDataToQuestion(formData: QuestionFormData): QuestionInputData | null {
  // Validate required fields
  if (
    !formData.moduleId ||
    !formData.questionText.trim() ||
    !formData.answer.trim() ||
    !formData.topic.trim() ||
    !formData.explanation.trim()
  ) {
    return null;
  }

  const filteredOptions = formData.options.filter((option) => option.trim());
  if (filteredOptions.length < 2) {
    return null;
  }

  return {
    moduleId: formData.moduleId,
    questionText: formData.questionText.trim(),
    hint: formData.hint?.trim() || undefined,
    options: filteredOptions,
    answer: formData.answer.trim(),
    explanation: formData.explanation.trim(),
    topic: formData.topic.trim(),
    difficulty: formData.difficulty,
    status: formData.status,
    statusNote: formData.statusNote?.trim() || undefined,
    image: formData.image,
    graphJsonString: formData.graphJson?.trim() || null,
  };
}
